// @flow

function getEnv (key): string {
  return process.env['host.' + key] || ''
}

export default {
  hostCms: getEnv('easy.cms'),
  importFrom: getEnv('easy.importFrom'),
  hostOldCms: getEnv('easy.oldCms'),

  hostFengjr: getEnv('easy.fengjr'),
  hostFjpc: getEnv('easy.fjpc'),

  hostYddH5: getEnv('easy.yddH5'),
  hostYddPc: getEnv('easy.yddPc'),

  hostAbroadH5: getEnv('easy.abroadH5'),
  hostAbroadPc: getEnv('easy.abroadPc')
}



// WEBPACK FOOTER //
// ./src/projects/easy/lib/config.js